<div class="warp-circles">
    <div *ngFor="let r of recipients,let i = index">
        <div *ngIf="recipients?.length!<5 || i<3" [ngClass]="isStatusReply ? 'true c{{i%3}}' : 'false '"
            class="recip  c{{i%3}}">
            <p> {{ r.firstName ? r.firstName.charAt(0).toUpperCase() : '' }}</p>
            <p>{{ r.lastName ? r.lastName.charAt(0).toUpperCase() : '' }}</p>
            <div *ngIf="getUserCount(r) > 1" class="count-badge">{{ getUserCount(r) }}</div>
        </div>
    </div>
    <div *ngIf="recipients?.length!>=5" class="recip plus">
        {{recipients?.length!-3}}+
    </div>
</div>